import React, { useContext, useState } from 'react'
import { Icon, Popconfirm } from 'antd'
import CustomIcon from '../override/Icon'
import { H4 } from '../override/Typography'
import { ThemeContext } from 'styled-components'
import DocumentsLinksModal from './DocumentsLinksModal'
import { formatBytes } from '../../share/helpers'
import SimpleList from '../override/SimpleList'
import { useTranslation } from 'react-i18next'

export default function DocumentLinks({
  linkedDocuments,
  handleUnlinkDocument,
  handleLinkDocument,
  isReadonly,
  record
}) {
  const theme = useContext(ThemeContext)
  const [documentsLinksModalVisible, setDocumentsLinksModalVisible] = useState(
    false
  )
  const { t } = useTranslation()

  return (
    <div>
      <SimpleList
        className="tour-existed-docs-link"
        header={<H4>{t('DOCUMENT_LINKS')}</H4>}
        extra={
          !isReadonly && (
            <CustomIcon
              type="add"
              style={{ fontSize: 30, color: theme.primary, cursor: 'pointer' }}
              onClick={() => {
                setDocumentsLinksModalVisible(true)
              }}
            />
          )
        }
        data={linkedDocuments}
        itemKey="_id"
        icon={document => (
          <Icon type="file-text" style={{ marginRight: 10, fontSize: 24 }} />
        )}
        mainInfo={document => document.fileName}
        subInfo={document => formatBytes(document.file[0].size)}
        action={document =>
          !isReadonly && (
            <Popconfirm
              title={t('UNLINK_DOCUMENT_CONFIRM')}
              onConfirm={() => handleUnlinkDocument(document._id)}
              okText={t('YES')}
              cancelText={t('NO')}
              arrowPointAtCenter
              placement="bottomRight"
            >
              <CustomIcon
                type="trash"
                style={{ color: theme.red, fontSize: 12 }}
              />
            </Popconfirm>
          )
        }
      />
      {documentsLinksModalVisible && (
        <DocumentsLinksModal
          visible={documentsLinksModalVisible}
          setVisible={setDocumentsLinksModalVisible}
          record={record}
          linkDocument={handleLinkDocument}
          filteredDocIds={linkedDocuments.map(doc => doc._id)}
        />
      )}
    </div>
  )
}
